<template>
  <div class="single-image-choice"></div>
</template>

<script>
export default {
  name: 'SingleImageChoice'
}
</script>

<style scoped></style>
